import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import Testimonials from "../components/sections/Testimonials";
import LeadSection from "../components/sections/LeadSection";
import { PROJECTS, IMAGES } from "../lib/site";

const FILTERS = ["All", "Residential", "Commercial", "Industrial", "Housing Society"];

export default function Projects() {
  const [filter, setFilter] = useState("All");
  const shown = filter === "All" ? PROJECTS : PROJECTS.filter((p) => p.type === filter);

  return (
    <main data-testid="projects-page">
      <PageHero
        kicker="Our work"
        title="2,000+ rooftops. One trusted team."
        subtitle="Explore a selection of homes, businesses and societies across the Tricity that now run on clean, self-generated solar power."
        image={IMAGES.comm1}
      />

      <section className="bg-cream py-20 md:py-28">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <div data-testid="project-filters" className="mb-10 flex flex-wrap gap-3">
            {FILTERS.map((f) => (
              <button key={f} onClick={() => setFilter(f)} data-testid={`filter-${f.toLowerCase().replace(" ", "-")}`}
                className={`rounded-full border px-5 py-2 text-sm font-semibold transition-colors ${
                  filter === f ? "border-forest bg-forest text-cream" : "border-line text-moss hover:border-forest hover:text-forest"}`}>
                {f}
              </button>
            ))}
          </div>

          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            <AnimatePresence mode="popLayout">
              {shown.map((p) => (
                <motion.div key={p.title + p.city} layout
                  initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }}
                  transition={{ duration: 0.4 }}
                  className="group relative h-72 overflow-hidden rounded-3xl">
                  <img src={p.image} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-obsidian/85 via-obsidian/10 to-transparent" />
                  <span className="absolute left-4 top-4 rounded-full bg-cream/90 px-3 py-1 font-mono text-xs font-semibold text-forest">{p.type}</span>
                  <div className="absolute bottom-5 left-5 right-5">
                    <p className="font-heading text-xl font-bold text-cream">{p.title}</p>
                    <div className="mt-1 flex items-center justify-between">
                      <span className="text-sm text-cream/70">{p.city}</span>
                      <span className="rounded-full bg-gold px-3 py-1 font-mono text-xs font-semibold text-obsidian">{p.stat}</span>
                    </div>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        </div>
      </section>

      <Testimonials />
      <LeadSection sourcePage="Projects Page" title="Your rooftop could be next." />
    </main>
  );
}
